import HeroSection from "../components/HeroSection";
import ProductHighlights from "../components/ProductHighlights";

function Home() {
  return (
    <div>
      <HeroSection />
      <ProductHighlights />
    </div>
  );
}

export default Home;
